import { useEffect } from 'react'
import { getListContractModification, getListContractModificationDocuments } from '../../../services/sKPI/contractModification.service';


const useGetContractModificationMaintainer = (mantainerList, setMantainer) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListContractModification();
                const response = serviceResponse.data;

                setMantainer(response.data);
            }
            catch (error) {
                setMantainer([])
            }
        }
        
        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

const useGetListContractModificationDocuments = (contractModificationId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListContractModificationDocuments(contractModificationId);

                if (serviceResponse.data.succeeded === true) {
                    const response = serviceResponse.data.data;

                    if (showDeactivatedDocuments) {
                        setDocumentLinkList(response);
                    }
                    else {
                        setDocumentLinkList(response.filter(x => x.deactivate === false));
                    }

                    setDocumentLinkListOriginal(response);
                }
                else {
                    setDocumentLinkList([]);
                    setDocumentLinkListOriginal([]);
                }
            }
            catch (error) {
                setDocumentLinkList([]);
                setDocumentLinkListOriginal([]);
            }
        }
        
        if (contractModificationId !== null && contractModificationId !== 0 && documentList === null && isPanelOpen === true) {
            getData()
        }
    }, [contractModificationId, documentList, setDocumentLinkList, setDocumentLinkListOriginal, isPanelOpen, showDeactivatedDocuments]);
}

export {
    useGetContractModificationMaintainer,
    useGetListContractModificationDocuments
}